(() => {
  const root = document.querySelector('[data-origin-product]');
  if (!root) return;
  const image = root.querySelector('[data-product-image]');
  const shapeInputs = [...root.querySelectorAll('[name="product-form"]')];
  const galleryControls = [...root.querySelectorAll('[data-gallery-view]')];
  const shapeThumbnail = root.querySelector('[data-gallery-shape-thumbnail]');
  const strapControl = root.querySelector('[data-gallery-view="strap"]');
  const strapThumbnail = root.querySelector('[data-gallery-strap-thumbnail]');
  const strapCaption = root.querySelector('[data-strap-caption]');
  const designLinks = [...root.querySelectorAll('[data-design-link]')];
  const designLink = designLinks[0];
  const family = root.querySelector('[data-product-family]');
  const designModeInputs = [...root.querySelectorAll('[name="product-design-mode"]')];
  const anchorGroup = root.querySelector('[data-product-anchors]');
  const anchorLinks = [...root.querySelectorAll('[data-design-anchor]')];
  const initialDesignMode = new URL(location.href).searchParams.get('design_mode') === 'individual' ? 'individual' : 'same';
  const initialModeInput = designModeInputs.find(input => input.value === initialDesignMode);
  if (initialModeInput) initialModeInput.checked = true;
  function updateDesignLinks(parameter, value) {
    const destination = new URL(designLink.href);
    if (parameter) destination.searchParams.set(parameter, value);
    const quantity = Number(destination.searchParams.get('quantity')) || 1;
    const chosenMode = designModeInputs.find(input => input.checked)?.value || 'same';
    const mode = quantity >= 2 ? chosenMode : 'same';
    destination.searchParams.set('design_mode', mode);
    destination.searchParams.delete('anchor');
    designLinks.forEach(link => { link.href = destination.href; });
    if (family) family.hidden = quantity < 2;
    if (anchorGroup) anchorGroup.hidden = mode !== 'individual';
    anchorLinks.forEach(link => {
      const anchor = Number(link.dataset.designAnchor);
      link.hidden = mode !== 'individual' || anchor > quantity;
      const anchorDestination = new URL(destination.href);
      anchorDestination.searchParams.set('design_mode', 'individual');
      anchorDestination.searchParams.set('anchor', String(anchor));
      link.href = anchorDestination.href;
    });
  }
  designModeInputs.forEach(input => input.addEventListener('change', () => {
    updateDesignLinks();
    const url = new URL(location.href);
    url.searchParams.set('design_mode', input.value);
    url.searchParams.delete('anchor');
    history.replaceState(null, '', url);
  }));
  const bundleInputs = [...root.querySelectorAll('[name="bundle-quantity"]')];
  const priceLabels = [...root.querySelectorAll('[data-product-price]')];
  const savingLabel = root.querySelector('[data-product-saving]');
  const compareLabel = root.querySelector('[data-product-compare]');
  function selectBundle(input) {
    input.checked = true;
    const bundlePrice = input.closest('label').querySelector('[data-bundle-total]');
    priceLabels.forEach(label => { label.textContent = bundlePrice.textContent; });
    if (savingLabel && compareLabel) {
      savingLabel.textContent = bundlePrice.dataset.bundleSaving || '';
      compareLabel.textContent = bundlePrice.dataset.bundleCompare || '';
      savingLabel.hidden = !savingLabel.textContent;
      compareLabel.hidden = !compareLabel.textContent;
    }
    updateDesignLinks('quantity', input.value);
  }
  const initialQuantity = new URL(location.href).searchParams.get('quantity');
  selectBundle(bundleInputs.find(input => input.value === initialQuantity) || bundleInputs[0]);
  bundleInputs.forEach(input => input.addEventListener('change', () => {
    selectBundle(input);
    const url = new URL(location.href);
    url.searchParams.set('quantity', input.value);
    history.replaceState(null, '', url);
  }));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let imageAnimation;
  let animateImageChange = false;
  image.addEventListener('load', () => {
    imageAnimation?.cancel();
    if (!animateImageChange || reducedMotion.matches || !image.animate) return;
    imageAnimation = image.animate([
      { opacity: .4, transform: 'scale(.985)' },
      { opacity: 1, transform: 'none' }
    ], { duration: 300, easing: 'cubic-bezier(.23,1,.32,1)' });
  });
  reducedMotion.addEventListener('change', event => { if (event.matches) imageAnimation?.cancel(); });
  const setImage = (largeSource, smallSource, description, largeWidth = 1200, smallWidth = 600) => {
    image.srcset = `${smallSource} ${smallWidth}w, ${largeSource} ${largeWidth}w`;
    image.src = largeSource;
    image.alt = description;
    image.dataset.zoomSrc = largeSource;
    image.classList.remove('origin-product-image--strap');
    strapCaption.hidden = true;
  };
  const selectShape = input => {
    input.checked = true;
    root.querySelector('[data-shape-title]').textContent = input.dataset.label;
    setImage(input.dataset.image, input.dataset.imageSmall, input.dataset.label);
    shapeThumbnail.src = input.dataset.imageSmall;
    strapControl.hidden = !input.dataset.strapImage;
    if (!strapControl.hidden) {
      strapControl.dataset.src = input.dataset.strapImage;
      strapControl.dataset.srcSmall = input.dataset.strapSmall;
      strapControl.dataset.width = input.dataset.strapWidth;
      strapControl.dataset.widthSmall = input.dataset.strapWidthSmall;
      strapControl.dataset.alt = input.dataset.strapAlt;
      strapThumbnail.src = input.dataset.strapThumbnail;
    }
    updateDesignLinks('form', input.value);
    galleryControls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.galleryView === 'shape')));
  };
  const initial = new URL(location.href).searchParams.get('form');
  selectShape(shapeInputs.find(input => input.value === initial) || shapeInputs[0]);
  shapeInputs.forEach(input => input.addEventListener('change', () => {
    animateImageChange = true;
    selectShape(input);
    const url = new URL(location.href);
    url.searchParams.set('form', input.value);
    history.replaceState(null, '', url);
  }));
  galleryControls.forEach(control => control.addEventListener('click', () => {
    animateImageChange = true;
    if (control.dataset.galleryView === 'shape') {
      selectShape(shapeInputs.find(input => input.checked));
      return;
    }
    if (control.hidden) return;
    setImage(control.dataset.src, control.dataset.srcSmall, control.dataset.alt || control.textContent.trim(), control.dataset.width, control.dataset.widthSmall);
    if (control === strapControl) {
      image.classList.add('origin-product-image--strap');
      strapCaption.hidden = false;
    }
    galleryControls.forEach(button => button.setAttribute('aria-pressed', String(button === control)));
  }));
  const dialog = document.querySelector('[data-zoom-dialog]');
  root.querySelector('[data-image-zoom]').addEventListener('click', () => {
    const zoomImage = dialog.querySelector('[data-zoom-image]');
    zoomImage.src = image.dataset.zoomSrc;
    zoomImage.alt = image.alt;
    dialog.showModal();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  if (location.hash === '#gestalten') location.replace(designLink.href);
})();

